<template>
    <div class="status px-4" id="sDownload">
        <div class="page-title pt-4">
            <v-row v-if="currentView === 'edit'">
                <v-col cols="12">
                    <h6 class="font-weight-bold text-h5">Asset Comments <span class="font-weight-medium"> - Internal
                            Status</span></h6>
                    <p class="pt-3 mb-0">Internal Status for a Assets.</p>
                </v-col>
            </v-row>
            <v-row v-if="currentView === 'history'">
                <v-col cols="12">
                    <h6 class="font-weight-bold text-h5">Asset Comments <span class="font-weight-medium"> -
                            History</span></h6>
                </v-col>
            </v-row>
        </div>
        <v-row v-if="currentView === 'edit'">
            <v-btn :right="true" :absolute="true" @click="editItem({}, 'New Asset')">
                <v-icon color="teal" @click="editItem({})">mdi-plus-circle-outline</v-icon>New Asset
            </v-btn>
        </v-row>
        <v-row>
            <v-col cols="12" style="margin-top: 5%;">
                <v-skeleton-loader :loading="loading" type="image" v-if="currentView === 'edit'">
                    <v-data-table :headers="headers" :loading="loading" :items="statusDetails"
                        :items-per-page="items_per_page_status" class="elevation-1 text-center"
                        :hide-default-footer="true">
                        <template v-slot:[`item.asset_id`]="{ item }">
                            <span @click="viewHistory(item.asset_id)" class="cursor">{{ item.asset_id
                                }}</span>
                        </template>
                        <template v-slot:[`item.internal_status`]="{ item }">
                            <span @click="viewHistory(item.asset_id)" class="cursor">{{ item.internal_status
                                }}</span>
                        </template>
                        <template v-slot:[`item.modified_by`]="{ item }">
                            <span @click="viewHistory(item.asset_id)" class="cursor">{{ item.modified_by
                                }}</span>
                        </template>
                        <template v-slot:[`item.status_date`]="{ item }">
                            <span @click="filterAssetHistory(item.asset_id)" class="cursor">
                                {{ (parseFloat(item.status_date) * 1000) | formatDateTime(getUserData.user.timezone) }}
                            </span>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn icon class="mx-0" @click="editItem(item, 'Edit Asset')">
                                <v-icon color="teal">mdi-pencil-box-outline</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:[`header.asset_id`]="{ header }">
                            {{ header.text }}
                            <v-menu offset-y :close-on-content-click="false" v-model="showmenu"
                                content-class="elevation-1 bg-white">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon small> mdi-menu </v-icon><span class="filterSelected"
                                            v-if="selectedStatusAssetID != '' && selectedStatusAssetID != null"></span>
                                    </v-btn>
                                </template>
                                <div style="background-color: #f5f5f5; width: 200px; height: 110px"
                                    class="px-3 pt-4 text-search">
                                    <v-text-field label="Asset ID" placeholder="Type Here"
                                        v-model="selectedStatusAssetID" @click:clear="clearAssetId()" outlined clearable
                                        dense></v-text-field>
                                    <v-btn depressed class="float-right my-2 white--text font-weight-bold" small
                                        color="rgb(0, 102, 124)"
                                        :disabled="selectedStatusAssetID === '' || selectedStatusAssetID === null ? true : false"
                                        @click="updateSelectedAssetID()">
                                        Apply
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <template v-slot:[`header.internal_status`]="{ header }">
                            {{ header.text }}
                            <v-menu offset-y :close-on-content-click="false" v-model="showCheckComments"
                                content-class="elevation-1">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon small> mdi-menu </v-icon><span class="filterSelected"
                                            v-if="isCommentsCheckAll != true && selectedComments.length != 0"></span>
                                    </v-btn>
                                </template>
                                <div style="background-color: #f5f5f5; width: 200px" class="px-3 pb-1 pt-2 label-font">
                                    <v-simple-checkbox @click="checkAllComments()" v-bind="isCommentsCheckAll"
                                        :value="isCommentsCheckAll" color="black" class="mb-3"></v-simple-checkbox><span
                                        class="all-label">Check All</span>
                                    <v-checkbox v-model="selectedComments" v-for="(item, i) in commentList"
                                        :label="item" :value="item" :key="i" color="black"></v-checkbox>
                                    <v-btn depressed class="
                      float-right
                      my-2
                      white--text
                      font-weight-bold
                      status-button
                    " small color="rgb(0, 102, 124)" :disabled="selectedComments.length == 0 ? true : false"
                                        @click="selctedStatusApply()">
                                        Apply
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <template v-slot:[`header.modified_by`]="{ header }">
                            {{ header.text }}
                            <v-menu offset-y :close-on-content-click="false" v-model="showUserMenu"
                                content-class="elevation-1 bg-white">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon small> mdi-menu </v-icon><span class="filterSelected"
                                            v-if="selectedmodifiedBy != '' && selectedmodifiedBy != null"></span>
                                    </v-btn>
                                </template>
                                <div style="background-color: #f5f5f5; width: 200px; height: 110px"
                                    class="px-3 pt-4 text-search">
                                    <v-text-field label="Modified By" placeholder="Type Here"
                                        v-model="selectedmodifiedBy" @click:clear="clearModifiedBy()" outlined clearable
                                        dense></v-text-field>
                                    <v-btn depressed class="float-right my-2 white--text font-weight-bold" small
                                        color="rgb(0, 102, 124)"
                                        :disabled="selectedmodifiedBy === '' || selectedmodifiedBy === null ? true : false"
                                        @click="updateSelectedmodifiedBy()">
                                        Apply
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!-- <template v-slot:[`header.actions`]="{ header }">
                            Actions
                        </template> -->
                    </v-data-table>
                </v-skeleton-loader>
                <internal-status-history v-else-if="currentView === 'history'" :asset-id="currentAssetId"
                    @go-back="goBack"></internal-status-history>
            </v-col>

            <!-- Modal Dialog for Editing -->
            <v-dialog v-model="dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ dialogTitle }}</span>
                        <p class="orange-clr" v-if="validationMessage">{{ validationMessage }}</p>
                    </v-card-title>
                    <v-snackbar :timeout="2000" :value="formSaved" color="success" rounded="pill">
                        Comment added successfully
                    </v-snackbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" @submit.prevent="saveChanges">
                            <v-text-field v-model="editedItem.asset_id" label="Asset ID"
                                :rules="[v => !!v || 'Asset ID is required', v => ['A', 'B', 'C'].includes(v.charAt(0)) || 'First character must be A, B, or C']"
                                outlined dense @input="validateForm"></v-text-field>
                            <v-select v-model="editedItem.internal_status" :items="internalStatusArr"
                                label="Internal Status" :rules="[v => !!v.length || 'Internal Status is required']"
                                multiple outlined dense @change="validateForm"></v-select>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark @click="closeDialog">Cancel</v-btn>
                        <v-btn color="success" :loading="loadSubmit" :disabled="!valid" @click="saveChanges">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row class="mx-1" v-if="currentView === 'edit'">
            <v-col class="d-block mx-0 px-0 mt-5">
                <v-select :items="pages" width="80px" :value="items_per_page_status" dense outlined
                    class="float-left wd-80" :menu-props="{ offsetY: true, contentClass: 'ambt-select' }"
                    @change="updatePerPageItems($event)"></v-select>
                <v-pagination flat v-model="destination_page" color="rgb(0, 102, 124)" :length="statusDetails.length > 0
                ? Math.ceil(totalRecords / items_per_page_status)
                : 1
                " :total-visible="5" class="float-right"></v-pagination>
            </v-col>
        </v-row>
    </div>
</template>
<script>
// eslint-disable-next-line
/* eslint-disable */
import exportPdf from "@/components/mixins/exportPdf.js";
import BarChart from "@/components/core/BarChart";
import InternalStatusHistory from './InternalStatusHistory.vue';
export default {
    mixins: [exportPdf],
    components: {
        BarChart,
        InternalStatusHistory
    },
    data() {
        return {
            valid: false,
            dialog: false,
            dialogTitle: 'New Asset',
            destination_page: 1,
            pages: [10, 50, 100, 200],
            showItem: false,
            editedItem: {},
            formSaved: false,
            loadSubmit: false,
            currentView: 'edit',
            currentAssetId: '',
            validationMessage: '',
            selectedmodifiedBy:'',
            showUserMenu: false,
            headers: [
                { text: "Asset", value: "asset_id", sortable: true, align: "center" },
                { text: "Comments ", value: "internal_status", sortable: false, align: "center" },
                { text: "Modified By", value: "modified_by",sortable: false, align: "center" },
                { text: "Date", value: "status_date", align: "center" },
                { text: "", value: "actions", sortable: false, align: "center" }
            ],
            totalRecords: 1,
            showCheckComments: false,
            isCommentsCheckAll: true,
            commentList: [],
            selectedComments: []
        };
    },
    computed: {
        loading() {
            return this.$store.getters.getLoading;
        },
        items_per_page_status() {
            return this.$store.getters.getStatusItemsPerPage;
        },
        statusDetails() {
            return this.$store.getters.getCommentsAssetList;
        },
        getUserData() {
            return this.$store.getters.getUserInfo;
        },
        selectedStatusAssetID: {
            get() {
                return this.$store.getters.getSelectedStatusAssetID
            },
            set(value) {
                this.$store.commit("SET_SELECTED_STATUS_ASSET_ID", value)
            }
        },
        internalStatusArr() {
            return this.$store.getters.getInternalStatusList.sort();
        },
    },
    watch: {
        destination_page(val) {
            this.getStatusDetails();
        },
        items_per_page_status(val) {
            if (this.destination_page !== 1) {
                this.destination_page = 1;
            } else {
                this.getStatusDetails();
            }
        },
        statusDetails(val) {
            if (val[0]) {
                this.totalRecords = val[0].count;
            } else {
                this.totalRecords = 0;
            }
        },
        selectedComments(val) {
            if (val.length == this.commentList.length) {
                this.isCommentsCheckAll = true;
            } else {
                this.isCommentsCheckAll = false;
            }
        },
    },
    beforeMount() {
        this.getStatusDetails();
        this.loadInternalStatus();
        this.commentList = this.internalStatusArr;
        this.selectedComments = this.commentList;
    },
    mounted() {
        this.isCommentsCheckAll = true;
        this.updatePerPageItems(10);
    },
    methods: {
        validateForm() {
            this.$refs.form.validate();
        },
        editItem(item, title) {
            this.dialogTitle = title;
            this.editedItem = { ...item };
            this.editedItem.internal_status = this.editedItem.internal_status != null ? this.editedItem.internal_status.split(",") : []
            this.dialog = true;
        },

        closeDialog() {
            this.dialog = false;
            this.editedItem = {};
        },
        async saveChanges() {
            this.formSaved = false
            this.loadSubmit = true
            if (this.valid) {
                var commentReq = { "widget": "ADD_ASSET_COMMENT" }
                var isPresent = this.statusDetails.find((item) => item.asset_id == this.editedItem.asset_id)
                if (isPresent) {
                    commentReq.action = "update"
                } else {
                    commentReq.action = "create"
                }
                var user = this.getUserData.user.name.given + " " + this.getUserData.user.name.surname;
                commentReq.assetId = this.editedItem.asset_id
                commentReq.modified_by = user
                commentReq.internalStatus = this.editedItem.internal_status.join(",")
                this.$store.dispatch('getDeviceData', commentReq)
                    .then(() => {
                        let vm = this
                        setTimeout(function () {
                            vm.formSaved = true;
                            vm.loadSubmit = false;
                            vm.dialog = false;
                            vm.getStatusDetails();
                        }, 4000)
                    })
                    .catch((error) => {
                        this.validationMessage = "Something went wrong...!"
                        console.error('Error:', error);
                    });
            }
        },
        viewHistory(assetId) {
            this.currentAssetId = assetId;
            this.currentView = 'history';
        },
        goBack() {
            this.currentView = 'edit';
        },
        loadInternalStatus() {
            this.$store.dispatch('getDeviceData', this.$store.dispatch('getDeviceData', { "widget": "INTERNAL-STATUS_LIST" }));
        },
        sum(data, prop) {
            var total = 0;
            for (var i = 0, _len = data.length; i < _len; i++) {
                total += parseInt(data[i][prop]);
            }
            return total;
        },
        updatePerPageItems(val) {
            this.$store.dispatch("updateStatusItemsPerPage", val);
        },
        getStatusDetails() {
            if (this.selectedComments.length > 0) {
                var commentsFilter = `,${this.selectedComments.join(',|,')},`;
            } else {
                var commentsFilter = "ALL";
            }
            if (this.destination_page === 1) {
                var page = 0;
            } else {
                var values = this.statusDetails.map((val) => val.index);
                var page = Math.max.apply(null, values);
            }
            const assetID = (this.selectedStatusAssetID != '' && this.selectedStatusAssetID != null) ? this.selectedStatusAssetID : 'ALL'
            const modifiedBy = (this.selectedmodifiedBy != '' && this.selectedmodifiedBy != null) ? this.selectedmodifiedBy : 'ALL'
            this.$store.dispatch("getDeviceData", {
                widget: "ASSET_COMMENTS_LIST",
                pageSize: this.items_per_page_status,
                page: this.destination_page,
                assetID: assetID,
                modifiedBy: modifiedBy,
                internalStatus: commentsFilter,
            });
        },
        selctedStatusApply() {
            if (this.destination_page !== 1) {
                this.destination_page = 1;
            } else {
                this.getStatusDetails();
            }

            this.showCheckComments = false
        },
        updateSelectedAssetID() {
            if (this.destination_page !== 1) {
                this.destination_page = 1;
            } else {
                this.getStatusDetails()
            }
            this.showmenu = false
        },
        updateSelectedmodifiedBy() {
            if (this.destination_page !== 1) {
                this.destination_page = 1;
            } else {
                this.getStatusDetails()
            }
            this.showUserMenu = false
        },

        checkAllComments() {
            if (!this.isCommentsCheckAll) {
                this.selectedComments = this.commentList;
            } else {
                this.selectedComments = [];
            }
        },
        clearAssetId() {
            this.selectedStatusAssetID = ''
            this.getStatusDetails()
            this.showmenu = false
        },
        clearModifiedBy() {
            this.selectedmodifiedBy = ''
            this.getStatusDetails()
            this.showUserMenu = false
        }
    },
};
</script>
<style lang="scss">
.ambt-select .theme--light.v-list {
    padding: 0;
}

.ambt-select .v-list-item {
    padding: 0 10px;
}

.label-font .v-label {
    font-size: 14px;
}

.label-font .v-input--selection-controls {
    margin-top: 0;
}

.bg-white fieldset {
    background: #fff;
}

tbody tr:nth-child(even) {
    background: #f9f9f9;
}

.cursor {
    cursor: pointer;
}

.status .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 10px;
}

.all-label {
    position: absolute;
    top: 9px;
    left: 45px;
    color: rgba(0, 0, 0, 0.6);
}

.bar-graph {
    background: #fff;
    padding: 15px 20px 0px 0;
    margin-bottom: 10px;
}

.graph-header {
    padding: 0px 0px 0px 20px;
}

.graph-header i {
    border: 3px solid #256c8f;
    border-radius: 50%;
    margin-left: 7px;
    padding: 5px;
    color: #256c8f !important;
}

.graph-header .v-icon {
    font-size: 30px;
}

.graph-header p {
    color: #555;
    font-weight: 600;
    text-align: center;
}

.graph-header h1 {
    font-size: 46px;
    margin-top: -5px;
}

.status-button {
    z-index: 9999999999999;
}

.text-search .v-text-field.v-text-field--enclosed .v-text-field__details {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/InternalStatus.vue